import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/style.scss'
import './appMixin.js'
import './permission.js'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { dictionaryText } from '@/utils/util'
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// import '@/icon/iconfont.css';
Vue.prototype.dictionaryText = dictionaryText
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.use(ElementUI)
Vue.use(Vant)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
